package com.essntl.features.service.ui.addextraservice

import core.validation.Form
import core.validation.field.Field
import core.validation.field.IntField
import core.validation.field.StringField
import core.validation.validator.IntMinValidator
import core.validation.validator.NonEmptyValidator

class AddExtraServiceFormValidation: Form() {
    val name = StringField(NonEmptyValidator)

    val description = StringField(NonEmptyValidator)

    val price = IntField(IntMinValidator(0, true))

    val amount = IntField(IntMinValidator(0, true))

    override val fields: List<Field> = listOf(
        name,
        description,
        price,
        amount
    )
}